module.exports = __webpack_public_path__ + "img/bj_lc_img.2464d18a.gif";